import { useContext } from 'react';
import { AppContext } from '../../context/Contexte';
const Actions = ({ showResult, calculate, prefer }) => {
  const { t } = useContext(AppContext);
  return (
    <>
      {!showResult && (
        <>
          <div className="action">
            <button
              onClick={calculate}
              className=" button btn__warning calule"
              disabled={!prefer}
            >
              {t('btn_calcul_text')}
            </button>
          </div>
          <div className="BottomText info">
            <p>
              <strong> {t('important')} : </strong>
              {t('recommendation_text')}
            </p>
          </div>
        </>
      )}
      <hr className="Sep" />
    </>
  );
};

export default Actions;
